<template>
  <div class="menu">
    <div v-if="platform === 'mobile'">
      <div class="pic">
        <img :src="logo" style="transform: scale(0.8); position:fixed; margin-top: -50px; left: 0%; z-index: 1"   width="100%">
      </div>
    </div>

    <!-- QR Code -->
    <div v-if="platform === 'desktop'">
      <div style="border: 1px solid #cbced3; display: inline-block; padding: 20px; padding-bottom: 12px; margin-top: 40px; width: 200px;">
        <qrcode-vue :value="qrcode" size="150" level="H"></qrcode-vue>
      </div>
      <div style="margin-top: 15px;">
        {{ $t('Login.no_service') }}<br>{{ $t('Login.scan_code') }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions, createNamespacedHelpers } from 'vuex'
import QrcodeVue from 'qrcode.vue'
const emc = createNamespacedHelpers('emc');


export default {
  data () {
    return {
      shopItem: null,
      channelId: '',
      platform: 'mobile',
      logo: '',
      channelData: {
        AuthToken: this.$route.query.Auth,
        Service: this.$route.params.service === 'FB' ? 'FB' : 'LINE',
        PhoneNumber: '',
        Name: this.$route.query.Name ? this.$route.query.Name : '',
        PageID: this.$route.query.Page,
        Img: '',
        date: this.$route.query.date
      },
    }
  },
  components: {
    QrcodeVue
  },
  mounted() {
    this.identify()
  },
  computed: {
    ...mapGetters({
      eilisProfile: 'eilisProfile',
      info: 'info',
      personalData: 'personalData',
      brandData: 'brandData',
      brandColor: 'brandColor',
      checking: 'checking'
    }),
    PData: {
      get () { return this.personalData },
      set(value) { this.storepersonal({ personal: value }); },
    },
    EFile: {
      get () { return this.eilisProfile },
      set(value) { this.storeEilisFile({ Efile: value }); },
    },
    storeBrandData: {
      get () { return this.brandData },
      set(value) { this.updateBrandData({ brand: value }); },
    },
    checkingStatus: {
      get () { return this.checking },
      set(value) { this.updateCheckingStatus({ status: value }); },
    }
  },
  methods: {
    ...mapMutations({
      storeEilisFile: 'storeEilisFile',
      updateBrandData: 'updateBrandData',
      storepersonal: 'storepersonal',
      updateCheckingStatus: 'updateCheckingStatus'
    }),
    ...mapActions({
      sendCode: 'sendCode',
      Decrypt: 'Decrypt',
      getConfig: 'getConfig',
      getImages: 'getImages',
      checkUserByToken: 'checkUserByToken',
      setAccount: 'setAccount',
      getregConfig: 'getregConfig',
      Encrypt: 'Encrypt',
      insertLocation: 'insertLocation',
    }),
    // 修正加密參數
    fixedString(str) {
      return str.replace(/%3D/g, '=').replace(/%26/g, '&').replace(/%3F/g, '?').replace(/%2B/g, '+').replace(/%2F/g, '/').replace(/%252F/g, '/').replace(/%253D/g, '=').replace(/%20/g, '+');
    },
    month(val) {
      if (val < 10) {
          return '0'+ val;
      } else {
          return val
      }
    },
    date(val) {
      if (val < 10) {
          return '0'+ val;
      } else {
          return val
      }
    },
    identify() {
      if ( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.platform = 'mobile';
        this.$loading.show()
        //U4d0f9c5b607115debefe303baabb4f71
        // if (this.channelData.Service === 'FB' || this.$route.query.Auth === 'Uecca21f83603b1097f538ae74b74377d' || this.$route.query.Auth === 'U4d0f9c5b607115debefe303baabb4f71' || this.$route.query.Auth === 'U12cd87201b3aff4a062004d920ec482' || this.$route.query.Auth === 'Uac1e77d862ffaaab19957607865b635c' || this.$route.query.Auth === 'Uac1e77d862ffaaab19957607865b635A') {
          if (this.channelData.Service === 'FB') {
          if (localStorage.getItem('personalInfo')) {
            this.getBrandData()
          } else {
            this.preLogin()
          }
        }
        else {
          if (localStorage.getItem('personalInfo')) {
            this.getBrandData()
          } else {
            this.LiffLogin();
          }
        }
      } else {
        this.platform = 'desktop';
        if (this.channelData.Service === 'FB') {
          this.qrcode = `http://m.me/${421955544535676}`;
        } else {
          this.qrcode = 'https://liff.line.me/1654949730-V7NB1G9Z';
        }
      }
    },
    getBrandData() {
      const querystring = window.location.search;
      this.channelId = this.fixedString(querystring).indexOf('&liff') !== -1 ? this.fixedString(querystring).split('&code=')[1].split('&liff')[0] : this.fixedString(querystring).split('&code=')[1].split('&shop=')[0];
      this.shopItem  = this.fixedString(querystring).split('shop=')[1];
      // console.log(channelId);
      // console.log(this.shopItem);
      this.sendCode({code: this.channelId})
      .then((res) => {
        // console.log(res);
        if (res.data.status === 10020 && res.data.result) {
          if (this.shopItem) {
            const B =  this.Decrypt(res.data.result)
            const C =  this.Decrypt(localStorage.getItem('personalInfo'))
            const D =  this.Decrypt(this.shopItem)
            Promise.all([B, C, D]).then(values => {
              this.logo = JSON.parse(values[0]).logo;
              // console.log('173');
              this.EFile = JSON.parse(values[0])
              this.PData = JSON.parse(values[1])
              this.storeBrandData = JSON.parse(values[2])
              // console.log(this.storeBrandData);
              this.insertLocation({service: 'LINE', auth: JSON.parse(values[0]).auth, shopNo: JSON.parse(values[2]).shopNo, shopName: JSON.parse(values[2]).shopName, phone: JSON.parse(values[1]).phone,name: JSON.parse(values[1]).name,})
              .then((res) => {
                // console.log(res);
                this.checkingStatus = true
                // console.log(values);
                // console.log(JSON.parse(values[0]));
                // console.log(JSON.parse(values[2]));
                this.$loading.hide()
                // return;
                if (this.channelData.Service === 'FB' || this.$route.query.Auth === 'Uecca21f83603b1097f538ae74b74377d' || this.$route.query.Auth === 'U4d0f9c5b607115debefe303baabb4f71' || this.$route.query.Auth === 'U12cd87201b3aff4a062004d920ec482' || this.$route.query.Auth === 'Uac1e77d862ffaaab19957607865b635c') {
                  this.$router.push(`/mainbottom/${this.channelData.Service}?Auth=${this.channelData.AuthToken}&checked=true`)
                } else {
                  this.$router.push(`/mainbottom/LINE?Auth=${this.channelData.AuthToken}&checked=true`)
                  // liff.init({
                  //   liffId: JSON.parse(values[0]).liffId
                  // })
                  // .then(() => {
                  // liff.getProfile()
                  //   .then((profile) => {
                  //     console.log('liff');
                  //     // console.log(profile);
                  //     this.channelData.AuthToken = profile.userId;
                  //     this.$router.push(`/mainbottom/LINE?Auth=${this.channelData.AuthToken}&checked=true`)
                  //     console.log(querystring);
                  //   })
                  // })
                  // .catch((err) => {
                  //   this.$createDialog({
                  //     type: 'alert',
                  //     showClose: false,
                  //     title: '系統提示',
                  //     content:'請更新您的LINE版本或重新登入',
                  //     // text: '你的訂單已成功送出，請前往訂單查詢查看',
                  //     confirmBtn: {
                  //       text: '確定',
                  //       active: true,
                  //       disabled: false,
                  //     },
                  //   }).show()
                  // })
                }
              })
            })
          } else {
            const B =  this.Decrypt(res.data.result)
            const C =  this.Decrypt(localStorage.getItem('personalInfo'))
            Promise.all([B, C]).then(values => {
              // console.log(values);
              // console.log(JSON.parse(values[0]));
              this.$loading.hide()
              this.logo = JSON.parse(values[0]).logo;
                // console.log('173');
                this.EFile = JSON.parse(values[0])
                this.PData = JSON.parse(values[1])
                // return;
                if (this.channelData.Service === 'FB' || this.$route.query.Auth === 'Uecca21f83603b1097f538ae74b74377d' || this.$route.query.Auth === 'U4d0f9c5b607115debefe303baabb4f71' || this.$route.query.Auth === 'U12cd87201b3aff4a062004d920ec482' || this.$route.query.Auth === 'Uac1e77d862ffaaab19957607865b635c') {
                  this.$router.push(`/mainbottom/${this.channelData.Service}?Auth=${this.channelData.AuthToken}`)
                } else {
                  liff.init({
                    liffId: JSON.parse(values[0]).liffId
                  })
                  .then(() => {
                  liff.getProfile()
                    .then((profile) => {
                      // console.log(profile);
                      this.channelData.AuthToken = profile.userId;
                      this.$router.push(`/mainbottom/LINE?Auth=${this.channelData.AuthToken}`)
                    })
                  })
                  .catch((err) => {
                    this.$createDialog({
                      type: 'alert',
                      showClose: false,
                      title: '系統提示',
                      content:'請更新您的LINE版本或重新登入',
                      // text: '你的訂單已成功送出，請前往訂單查詢查看',
                      confirmBtn: {
                        text: '確定',
                        active: true,
                        disabled: false,
                      },
                    }).show()
                  })
              }
            })
          }
        }
      })
    },
    preLogin() {
      const querystring = window.location.search;
      this.channelId = this.fixedString(querystring).indexOf('&liff') !== -1 ? this.fixedString(querystring).split('&code=')[1].split('&liff')[0] : this.fixedString(querystring).split('&code=')[1].split('&shop=')[0];
      this.shopItem  = this.fixedString(querystring).split('shop=')[1];
      // console.log(this.channelId);
      // console.log(this.shopItem);
      this.sendCode({code: this.channelId})
      .then((res) => {
        // console.log(res);
        if (res.data.status === 10020 && res.data.result) {
          if (this.shopItem) {
            const A =  this.Decrypt(res.data.result)
            const B =  this.Decrypt(this.shopItem)
            Promise.all([A, B]).then(values => {
              // console.log(values);
              this.$loading.hide()
              this.EFile = JSON.parse(values[0]);
              // console.log(this.EFile);
              this.logo = this.EFile.logo;
              this.storeBrandData = JSON.parse(values[1])
              // console.log(this.storeBrandData);
              this.Login();
            })
          } else {
            this.Decrypt(res.data.result)
            .then((res) => {
              this.$loading.hide()
              this.EFile = JSON.parse(res);
              // console.log(this.EFile);
              this.logo = this.EFile.logo;
              this.Login();
            })
          }
        }
      })
    },
    LiffLogin() {
      const querystring = window.location.search;
      // console.log(querystring);
      // console.log(this.fixedString(querystring));
      // console.log(this.fixedString(querystring).indexOf('&liff') !== -1);
      this.channelId = this.fixedString(querystring).indexOf('&liff') !== -1 ? this.fixedString(querystring).split('&code=')[1].split('&liff')[0] : this.fixedString(querystring).split('&code=')[1].split('&shop=')[0];
      this.shopItem  = this.fixedString(querystring).split('shop=')[1];
      // console.log(this.channelId);
      // console.log(this.shopItem);
      this.sendCode({code: this.channelId})
      .then((res) => {
        // console.log(res);
        if (res.data.status === 10020 &&  res.data.result) {
          if (this.shopItem) {
            // console.log(res.data.result);
            const A =  this.Decrypt(res.data.result)
            const B =  this.Decrypt(this.shopItem)
            Promise.all([A, B]).then(values => {
              // console.log(values);
              this.$loading.hide()
              this.EFile = JSON.parse(values[0]);
              // console.log(this.EFile);
              this.logo = this.EFile.logo;
              this.storeBrandData = JSON.parse(values[1])
              // console.log(this.storeBrandData);
              // return;
              liff.init({
                liffId: this.EFile.liffId
              })
              .then(() => {
              liff.getProfile()
                .then((profile) => {
                  this.channelData.AuthToken = profile.userId;
                  // console.log(this.channelData.AuthToken);
                  this.channelData.Img = profile.pictureUrl;
                  this.Login();
                })
              })
              .catch((err) => {
                alert(err);
                //alert('已離開會員卡。');
                liff.closeWindow();
              })
            })
          } else {
            this.Decrypt(res.data.result)
            .then((res) => {
              this.$loading.hide()
              this.EFile = JSON.parse(res);
              // console.log(this.EFile);
              this.logo = this.EFile.logo;
              liff.init({
                liffId: this.EFile.liffId
              })
              .then(() => {
              liff.getProfile()
                .then((profile) => {
                  this.channelData.AuthToken = profile.userId;
                  // console.log(this.channelData.AuthToken);
                  this.channelData.Img = profile.pictureUrl;
                  this.Login();
                })
              })
            })
          }
        }
      })
    },
    Login() {
      // console.log(this.eilisProfile);
      // console.log(this.eilisProfile.auth);
      // console.log(this.channelData.AuthToken);
      // console.log(this.channelData.Service);
      this.checkUserByToken({ service: this.channelData.Service, token: this.channelData.AuthToken, auth: this.eilisProfile.auth, })
      .then((res) => {
        // console.log(res);
        // return;
        // this.platform = 'mobile';
        // console.log(Object.values(res.data));
        if (res.data.result === null) {
          this.$router.push(`/initial/${this.channelData.Service}?Auth=${this.channelData.AuthToken}&Img=${this.channelData.Img}`)
        } else if (res.data.result.addTime) {
          this.PData = res.data.result;
          // 加密暫存個人資料
          this.Encrypt(res.data.result).then((res) => {
            localStorage.setItem('personalInfo', res)
          })
          if (this.shopItem) {
            this.insertLocation({service: 'LINE', auth: this.eilisProfile.auth, shopNo: this.brandData.shopNo, shopName: this.brandData.shopName, phone: res.data.result.phone,name: res.data.result.name,})
            .then((res) => {
              this.checkingStatus = true
              this.$router.push(`/mainbottom/${this.channelData.Service}?Auth=${this.channelData.AuthToken}&checked=true`)
            })
          } else {
            this.$router.push(`/mainbottom/${this.channelData.Service}?Auth=${this.channelData.AuthToken}&checked=true`)
          }
        } else if (res.data.Message === '查無此用戶') {
          this.loading = false;
        }
      })
      .catch((err) => {
        this.loading = false;
        alert(err)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
      /* Absolute Center Spinner */
  .loadingIcon {
    display: flex; // 置中
    align-items: center; // 置中
    justify-content: center; // 置中
    margin: 0 auto;
    position: fixed;
    margin: 0 auto;
    position: fixed;
    top: 70%;
    left: 0;
    right: 0;
  }
  .menu {
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    max-width: 540px;
    min-width: 300px;
    height: 750px;
    background-color: #ffffff;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
  .pic {
    position: fixed;
    z-index: 10000;
    margin-top: 35%;
    margin-left: 10px;
    -webkit-animation-name: myframes;
            animation-name: myframes;
    -webkit-animation-duration: 300ms;
            animation-duration: 300ms;
    -webkit-animation-timing-function: ease-in-out;
            animation-timing-function: ease-in-out;
    -webkit-animation-delay: 0s;
            animation-delay: 0s;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-animation-direction: normal;
            animation-direction: normal;
    -webkit-animation-fill-mode: forwards;
            animation-fill-mode: forwards;
  }
.box.is-paused {
  -webkit-animation-play-state: paused;
          animation-play-state: paused;

}
@keyframes myframes {
  0% {
    // -webkit-transform: scale(1) translateX(200px) rotate(0deg);
    //         transform: scale(1) translateX(200px) rotate(0deg);
    opacity: 0.1;
  }
  // 50% {
  //   -webkit-transform: scale(0.5) rotate(0deg);
  //           transform: scale(0.5) rotate(0deg);
  //   opacity: 0.5;
  // }
  // 80% {
  //   -webkit-transform: scale(0.8) rotate(0deg);
  //           transform: scale(0.8) rotate(0deg);
  //   opacity: 0.8;
  // }
  100% {
    // -webkit-transform: scale(1) translateX(0px) rotate(0deg);
    //         transform: scale(1) translateX(0px) rotate(0deg);
    opacity: 1;
  }
}
</style>
